import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone } from 'lucide-react';

const WB_LOGO = 'https://customer-assets.emergentagent.com/job_110eaf2c-e2da-4799-9c05-6d381eae4282/artifacts/13g1t9qc_BBEED318-098A-4FB8-8AEB-680648F471A0.jpeg';

const FOOTER_LINKS = [
  { label: 'Experience', to: '/experience' },
  { label: 'About', to: '/about' },
  { label: 'Media', to: '/media' },
  { label: 'Contact', to: '/contact' },
];

export default function SiteFooter() {
  useEffect(() => {
    if (window.twttr) window.twttr.widgets.load();
  }, []);

  return (
    <footer className="bg-gray-950 border-t border-gray-800">
      {/* X Feed Strip */}
      <div className="border-b border-gray-800">
        <div className="container mx-auto px-6 py-8 max-w-6xl">
          <div className="grid md:grid-cols-3 gap-8 items-start">
            <div className="md:col-span-1">
              <p className="text-white font-bold text-lg mb-2">Latest from @coachwbraxton</p>
              <p className="text-gray-500 text-sm mb-4">Follow for film study notes, coaching insights, and football content.</p>
              <div className="flex flex-col space-y-2">
                <a href="https://twitter.com/coachwbraxton" target="_blank" rel="noopener noreferrer" className="text-blue-400 hover:text-blue-300 text-sm font-medium transition-colors">Follow on X &rarr;</a>
                <a href="https://youtu.be/AMNiE0D-0wU" target="_blank" rel="noopener noreferrer" className="text-blue-400 hover:text-blue-300 text-sm font-medium transition-colors">Watch on YouTube &rarr;</a>
              </div>
            </div>
            <div className="md:col-span-2 bg-gray-900 rounded-xl p-4 max-h-[300px] overflow-hidden">
              <a
                className="twitter-timeline"
                data-width="100%"
                data-height="260"
                data-theme="dark"
                data-chrome="noheader noborders transparent nofooter"
                data-tweet-limit="2"
                href="https://twitter.com/coachwbraxton"
              >
                Loading...
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Main Footer */}
      <div className="container mx-auto px-6 py-12 max-w-6xl">
        <div className="grid md:grid-cols-4 gap-10">
          <div className="md:col-span-1">
            <Link to="/" className="flex items-center space-x-3 mb-4">
              <img src={WB_LOGO} alt="WB" className="h-12 w-12 object-contain rounded-lg" />
              <div>
                <p className="text-white font-bold">Weldon Braxton</p>
                <p className="text-gray-500 text-xs">College Football Coach</p>
              </div>
            </Link>
            <p className="text-gray-500 text-sm leading-relaxed">
              Film tells the truth. We help you find the answers.
            </p>
          </div>

          <div>
            <p className="text-white font-semibold text-sm mb-4">Pages</p>
            <ul className="space-y-2">
              {FOOTER_LINKS.map((link) => (
                <li key={link.to}>
                  <Link to={link.to} className="text-gray-500 hover:text-white text-sm transition-colors">{link.label}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <p className="text-white font-semibold text-sm mb-4">Credentials</p>
            <ul className="space-y-2 text-sm text-gray-500">
              <li>College Head Coach</li>
              <li>Championship Builder</li>
              <li>Offensive Coordinator</li>
              <li>AFCA 35 Under 35</li>
              <li>M.S. Sport Administration</li>
            </ul>
          </div>

          <div>
            <p className="text-white font-semibold text-sm mb-4">Contact</p>
            <div className="space-y-3">
              <a href="mailto:weldonbraxton@gmail.com" className="flex items-center space-x-2 text-gray-500 hover:text-white text-sm transition-colors">
                <Mail className="h-4 w-4" />
                <span>weldonbraxton@gmail.com</span>
              </a>
            </div>
            <Link to="/contact" className="inline-block mt-5 bg-blue-600 hover:bg-blue-700 text-white text-sm font-semibold px-6 py-2.5 rounded-full transition-all">
              Get in Touch
            </Link>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-10 pt-6 flex flex-col md:flex-row justify-between items-center text-xs text-gray-600">
          <p>&copy; 2025 Weldon Braxton. All rights reserved.</p>
          <p>M.S. Sport Administration &mdash; Liberty University</p>
        </div>
      </div>
    </footer>
  );
}
